var _style, _g, _path, _path2, _path3, _path4, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFeedLight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28.4 28.4",
    style: {
      enableBackground: "new 0 0 28.4 28.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B5B5B5;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "17.3,3.9 13.3,1.1 18.7,3.6 18.7,5.8 19.6,5.8 19.6,3.4 13.2,0.4 7,3.4 6.9,5.7 17.3,5.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "19.6,17.2 19.6,6.5 18.7,6.5 18.8,17.2  "
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.3,6.5H7V7c2.6,0.1,4.8,2.2,4.8,4.9S9.6,16.8,7,16.8v0.5h10.5L17.3,6.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.9,7.4c-2.5,0-4.4,2-4.4,4.5c0,2.4,2,4.4,4.4,4.4c2.5,0,4.5-2,4.5-4.4S9.3,7.4,6.9,7.4z M6.9,15.6 c-2.1,0-3.7-1.7-3.7-3.7s1.7-3.7,3.7-3.7s3.7,1.7,3.7,3.7S8.9,15.6,6.9,15.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.2,23.8l0.1-2.1l3.1-2v1.1l0.1-0.1l0,0c0.2-0.6,0.6-0.7,0.9-0.7c0.1,0,0.2,0,0.3,0v-2.1L6.9,18l-0.1,9.9h1.3 v-8.1l3.3,2v2H15.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.8,28h13.7c0,0-0.5-0.9-0.5-1.2c0-0.3-0.1-0.6-0.4-0.7c-0.1-0.1-0.2-0.7-0.4-0.7S25,25.1,24.9,25 c0-0.2-0.2-0.2-0.4-0.2c-0.2,0-0.1-0.2-0.2-0.3s-0.2-0.1-0.4-0.2c-0.2-0.1-0.1-0.1-0.2-0.3s-0.2-0.2-0.3-0.5s-0.2-0.5-0.5-0.6 s-0.2,0.1-0.3-0.2s-0.3-0.6-0.4-0.5s-0.3-0.3-0.3-0.3s-0.1-0.2-0.4-0.2c-0.3-0.1-0.1-0.1-0.3-0.2c-0.1,0-0.5-0.7-0.8-0.6 c-0.1,0-0.5-0.3-0.7-0.4c-0.2,0-0.7-0.3-0.9,0.3c-0.1,0.3-0.3,0.2-0.4,0.6s-0.5,0.4-0.8,0.5s-0.3,0.4-0.5,0.6s-0.6,0.2-0.8,0.5 c-0.2,0.3-0.5,0.4-0.6,0.8c0,0.3-0.2,0.6-0.4,0.7c-0.2,0-0.3,0.7-0.5,0.7s-0.4,0.2-0.4,0.5s-0.1,0.2-0.3,0.3s-0.3,0.2-0.3,0.4 c0,0.2-0.1,0.3-0.3,0.4s-0.3,0.1-0.4,0.3c-0.1,0.2-0.1,0.3-0.2,0.4S12.8,28,12.8,28z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,11.9c0-0.7-0.6-1.3-1.3-1.3l-1.5,0c-0.4,0-0.8,0.2-1,0.5c-0.1,0.1-0.2,0.3-0.2,0.5c0,0.1,0,0.2,0,0.3 l0,0.3h0.5l0-0.3c0-0.1,0-0.2,0.1-0.3c0.1-0.3,0.4-0.5,0.7-0.5l1.5,0c0.4,0,0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.7,0.7l-0.7,0 C8,12.8,7.8,13,7.7,13.2l1.1,0C9.5,13.2,10,12.6,10,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.7,12.2c0-0.1,0-0.2,0-0.3l0-0.3H7.3v0.3c0,0.1,0,0.2-0.1,0.3c-0.1,0.3-0.4,0.5-0.7,0.5l-1.5,0 c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7l0.7,0C5.8,11,6,10.8,6.1,10.6l-1.1,0c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3 l1.5,0c0.4,0,0.8-0.2,1-0.5C7.6,12.5,7.7,12.4,7.7,12.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeedLight);
export default __webpack_public_path__ + "static/media/icon_feed_light.40102039fb0ac18ad2ece5fc540ed8cf.svg";
export { ForwardRef as ReactComponent };